import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Admin from '../views/Admin.vue'
import Tutorial from '../views/Tutorial.vue'
import VideoCopy from '../views/VideoCopy.vue'
import CreativeHub from '../views/CreativeHub.vue'
import FreeCanvasWorkspace from '../views/FreeCanvasWorkspace.vue'
import ConversationWorkflow from '../views/ConversationWorkflow.vue'
import Projects from '../views/Projects.vue'
import Assets from '../views/Assets.vue'
import DirectorDeck3D from '../views/DirectorDeck3D.vue'
import PlusLanding from '../views/PlusLanding.vue'
import PlusPricing from '../views/PlusPricing.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import UserAgreement from '../views/UserAgreement.vue'
import VipMembershipAgreement from '../views/VipMembershipAgreement.vue'
import ScriptStudio from '../views/ScriptStudio.vue'
import { openLoginModal } from '../utils/loginGate'
import { warmVipPlansForPricing } from '../utils/vipPlansCache'

Vue.use(VueRouter)

const routes = [
  {
    path: '/workspace',
    name: 'FreeCanvasWorkspace',
    component: FreeCanvasWorkspace,
    meta: { requiresAuth: true }
  },
  {
    path: '/chat-workflow',
    name: 'ConversationWorkflow',
    component: ConversationWorkflow,
    meta: { requiresAuth: true }
  },
  {
    path: '/creative-hub',
    name: 'CreativeHub',
    component: CreativeHub,
    meta: { requiresAuth: true }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta: { requiresAuth: true }
  },
  {
    path: '/assets',
    name: 'Assets',
    component: Assets,
    meta: { requiresAuth: true }
  },
  {
    path: '/director-deck',
    name: 'DirectorDeck3D',
    component: DirectorDeck3D,
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    name: 'PlusLanding',
    component: PlusLanding,
    meta: { requiresAuth: false }
  },
  {
    path: '/pricing',
    name: 'PlusPricing',
    component: PlusPricing,
    meta: { requiresAuth: false },
    beforeEnter(to, from, next) {
      warmVipPlansForPricing()
        .then(() => next())
        .catch(() => next())
    }
  },
  { path: '/plus', redirect: '/' },
  { path: '/plus/pricing', redirect: '/pricing' },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/video-copy',
    name: 'VideoCopy',
    component: VideoCopy,
    meta: { requiresAuth: true }
  },
  {
    path: '/script-studio',
    name: 'ScriptStudio',
    component: ScriptStudio,
    meta: { requiresAuth: true }
  },
  { path: '/script-create', redirect: '/script-studio' },
  // {
  //   path: '/',
  //   name: 'VideoCopy',
  //   component: VideoCopy,
  //   meta: { requiresAuth: true }
  // },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: Tutorial
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { requiresAuth: false }
  },
  {
    path: '/terms',
    name: 'UserAgreement',
    component: UserAgreement,
    meta: { requiresAuth: false }
  },
  {
    path: '/vip-agreement',
    name: 'VipMembershipAgreement',
    component: VipMembershipAgreement,
    meta: { requiresAuth: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫：未登录仍可进入需登录页，由全局遮罩弹窗完成登录
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token')

  if (to.meta.requiresAuth && !token) {
    openLoginModal()
  }
  next()
})

export default router



